import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BackdropCircular } from 'components';
import SelectedPackageDetails from './SelectedPackageDetails';
import QuotePackages from './QuotePackages';


const QuotePackagesContainer = ({handleCancel}) => {
  const [selectedPackage, setSelectedPackage] = useState(null);

  const {
    packagesLoading,
    quoteProductsLoading,
    loadingQuoteProductSubscriptionOptions
  } = useSelector((state: IReduxState) => state.quote);

  return (
    <div className="mt-2">
      {selectedPackage ?
        <SelectedPackageDetails
          selectedPackage={selectedPackage}
          setSelectedPackage={setSelectedPackage}
          handleCancel={handleCancel}
        />
        : <QuotePackages setSelectedPackage={setSelectedPackage} />
      }
      <BackdropCircular loading={packagesLoading || loadingQuoteProductSubscriptionOptions || quoteProductsLoading} local />
    </div>
  );
};

export default QuotePackagesContainer;
